var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Validation = function Validation(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 20 2 11' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        '!'
      ),
      React.createElement('path', { id: 'Fill-2', d: 'M1 27c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1s1 .4 1 1v5c0 .6-.4 1-1 1zm0 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z', className: 'st0'
      })
    )
  );
};
/*eslint-enable */

export default Validation;
//# sourceMappingURL=Validation.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Validation.js